import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Grid,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ToggleButton,
  ToggleButtonGroup,
  Select,
  Checkbox,
  FormGroup,
  FormControlLabel,
  MenuItem,
  Stack,
  Collapse,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RefreshIcon from '@mui/icons-material/Refresh';
import SyncIcon from '@mui/icons-material/Sync';
import ApiConfig from '../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { formatLocalDateTime, toLocalDate } from '../../utils/dateTime';
import { useLatestRef, useMountEffect } from '../../utils/hooks';

export default function RobotScheduler(props) {
    const { keycloak } = useKeycloak();
    const a = new ApiConfig(keycloak)
    const apiConfig = a.api()

    const [mode, setMode] = useState("single");
    const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const [repeatDays, setRepeatDays] = useState([]);
    const [selectedMission, setSelectedMission] = useState({}); // Selected mission for scheduling
    const [schedules, setSchedules] = useState([]) // Current schedules
    const [selectedDate, setSelectedDate] = useState(new Date()); // For single day schedule
    const [selectedStartTime, setSelectedStartTime] = useState(new Date().getTime()) // For Multiday and single day schedule
    const [selectedEndTime, setSelectedEndTime] = useState(new Date().getTime()) // For Multiday and single day schedule
    const [startFilteredDate, setStartFilteredDate] = useState(new Date(new Date().setHours(0, 0, 0, 0))); // For filtered date
    const [endFilteredDate, setEndFilteredDate] = useState(new Date(new Date().setHours(23, 59, 59, 99))); // For filtered date
    const [startDate, setStartDate] = useState(new Date()); // For Multiday schedule
    const [endDate, setEndDate] = useState(new Date()); // For Multiday schedule
    const [missions, setMissions] = useState([]); // Get all missions from backend
    const [open, setOpen] = useState(false);
    const [filteredSchedules, setFilteredSchedules] = useState([])
    const [expandedSchedule, setExpandedSchedule] = useState(null);
    const [isRefreshingSchedule, setIsRefreshingSchedule] = useState(false);
    const [isRepullingSchedule, setIsRepullingSchedule] = useState(false);

    const handleDeleteSchedule = (id) => {
        apiConfig.deleteSchedule(id).then((response)=>{
            console.log(response)
            retrieveMissionsAndSchedules()
        })
    };

    const retrieveMissionsAndSchedules = () => {
        return Promise.all([
            apiConfig.fetchMissionInfo(),
            apiConfig.fetchScheduleInfo(props.robotId ? props.robotId : "e856f3b3-c04c-4ff3-af63-2c5e42f0f542")
        ]).then(results => {
            setMissions(results[0].RobotResponse)
            setSelectedMission(results[0].RobotResponse[0])
            setSchedules(results[1].RobotResponse)
            console.log(results[1].RobotResponse)
        }).catch(error => {
            console.error(error);
        });
    }

    const handleRefreshSchedule = () => {
        if (isRefreshingSchedule) return;

        setIsRefreshingSchedule(true);
        retrieveMissionsAndSchedules()
            .finally(() => setIsRefreshingSchedule(false));
    }

    const handleRepullSchedule = () => {
        if (!props.robotName || isRepullingSchedule) return;

        setIsRepullingSchedule(true);
        apiConfig.repullScheduleForRobot(props.robotName)
            .then(retrieveMissionsAndSchedules)
            .catch(console.error)
            .finally(() => setIsRepullingSchedule(false));
    }

    useMountEffect(() => {
        // console.log(props)
        retrieveMissionsAndSchedules()
        return () => {
            // This code runs when the component is unmounted
            // Perform cleanup or unsubscribe from resources
            // console.log("Disconnecting from websocket...")
            // socket.close()
        };
    }, []);

const handleFilterDate = () => {
        console.log(schedules)
        console.log(`start date ${startFilteredDate} end date ${endFilteredDate}`)

        const filtered = schedules.filter((mission) => {
            if (!startFilteredDate || !endFilteredDate) return false;
            const missionDate = toLocalDate(mission.MissionStartAt)
            return missionDate >= startFilteredDate && missionDate <= endFilteredDate;
        });
        setFilteredSchedules(filtered)
    }

    const handleFilterDateRef = useLatestRef(handleFilterDate);

    useEffect(() => {
        handleFilterDateRef.current();
    }, [schedules, startFilteredDate, endFilteredDate, handleFilterDateRef]);

    const getSchedulePeriod = (value) => {
        const date = toLocalDate(value);
        if (!date) return 'Unscheduled';
        const hour = date.getHours();
        if (hour < 12) return 'Morning';
        if (hour < 18) return 'Afternoon';
        return 'Night';
    }

    const getScheduleDateHeader = (value) => {
        if (!toLocalDate(value)) return 'No start date';
        return formatLocalDateTime(value, { weekday: 'short', month: 'short', day: 'numeric' });
    }

    const groupedSchedules = [...filteredSchedules]
        .sort((a, b) => (toLocalDate(b.MissionStartAt)?.getTime() || 0) - (toLocalDate(a.MissionStartAt)?.getTime() || 0))
        .reduce((groups, schedule) => {
            const dateLabel = getScheduleDateHeader(schedule.MissionStartAt);
            const period = getSchedulePeriod(schedule.MissionStartAt);
            const key = `${dateLabel}-${period}`;
            const existingGroup = groups.find(group => group.key === key);

            if (existingGroup) {
                existingGroup.schedules.push(schedule);
            } else {
                groups.push({
                    key,
                    dateLabel,
                    period,
                    schedules: [schedule],
                });
            }

            return groups;
        }, []);

  const handleSchedule = () => {
    if (!selectedMission) return;
    console.log(startDate, endDate)
    if (mode === "single") {
        const schedule_start_time = selectedDate.setHours(new Date(selectedStartTime).getHours(), new Date(selectedStartTime).getMinutes(), 0, 0)
        const schedule_end_time = selectedDate.setHours(new Date(selectedEndTime).getHours(), new Date(selectedEndTime).getMinutes(), 0, 0)
        const iso_schedule_start_time = new Date(schedule_start_time).toISOString()
        const iso_schedule_end_time = new Date(schedule_end_time).toISOString()
        const schedule = {
            RobotTableId: props.robotId,
            RobotMissionId: selectedMission.Id,
            MissionStartAt: iso_schedule_start_time,
            MissionEndAt: iso_schedule_end_time,
            ScheduledTasklists: [],
            Deleted: false,
            Status: "PENDING",
            CreatedBy: "system",
            UpdatedBy: "system",
        }

        selectedMission.Tasklists.forEach((tasklist, index) => {
            console.log(tasklist)
            var ScheduledTasklist = {
                MissionTasklistId: tasklist.Id,
                Status: "PENDING",
                ScheduledTasks: [],
                Deleted: false,
                CreatedBy: "system",
                UpdatedBy: "system",
            }
            tasklist.RobotTasklistId.Tasks.forEach((task, index)=>{
            var ScheduledTask = {
                TasklistTaskId: task.Id,
                Status: "PENDING",
                Deleted: false,
                CreatedBy: "system",
                UpdatedBy: "system",
            }
            ScheduledTasklist.ScheduledTasks.push(ScheduledTask)
            })
            schedule.ScheduledTasklists.push(ScheduledTasklist)
        });
        console.log(schedule)
        // setSchedules([...schedules, schedule]);
        apiConfig.createSchedule(schedule).then((response)=>{
            console.log(response)
            retrieveMissionsAndSchedules()
        })
    } else if (startDate && endDate) {
        console.log("Start date:", startDate, "End date:", endDate)
        const newSchedules = [];
        const current = startDate
        console.log(current.getTime(), endDate.getTime())
        while (current.getTime() <= endDate.getTime()) {
            if (repeatDays.includes(daysOfWeek[current.getDay()])){
                const schedule_start_time = current.setHours(new Date(selectedStartTime).getHours(), new Date(selectedStartTime).getMinutes(), 0, 0)
                const schedule_end_time = current.setHours(new Date(selectedEndTime).getHours(), new Date(selectedEndTime).getMinutes(), 0, 0)
                const iso_schedule_start_time = new Date(schedule_start_time).toISOString()
                const iso_schedule_end_time = new Date(schedule_end_time).toISOString()
                const schedule = {
                    RobotTableId: props.robotId,
                    RobotMissionId: selectedMission.Id,
                    MissionStartAt: iso_schedule_start_time,
                    MissionEndAt: iso_schedule_end_time,
                    ScheduledTasklists: [],
                    Deleted: false,
                    Status: "PENDING",
                    CreatedBy: "system",
                    UpdatedBy: "system",
                }
                selectedMission.Tasklists.forEach((tasklist, index) => {
                    // console.log(tasklist)
                    var ScheduledTasklist = {
                        MissionTasklistId: tasklist.Id,
                        Status: "PENDING",
                        ScheduledTasks: [],
                        Deleted: false,
                        CreatedBy: "system",
                        UpdatedBy: "system",
                    }
                    tasklist.RobotTasklistId.Tasks.forEach((task, index)=>{
                    var ScheduledTask = {
                        TasklistTaskId: task.Id,
                        Status: "PENDING",
                        Deleted: false,
                        CreatedBy: "system",
                        UpdatedBy: "system",
                    }
                    ScheduledTasklist.ScheduledTasks.push(ScheduledTask)
                    })
                    schedule.ScheduledTasklists.push(ScheduledTasklist)
                });
                newSchedules.push(schedule)
                apiConfig.createSchedule(schedule).then((response)=>{
                    console.log(response)
                })
                // setTimeout(() => {
                //     setShowNotification(false);
                // }, 1000);
            }

            current.setDate(current.getDate() + 1);
        }
        console.log(newSchedules)
        // setSchedules(prev => [...prev, ...newSchedules])
        retrieveMissionsAndSchedules()

        // let current = new Date(startDate);
        // while (current <= endDate) {
        //     newSchedules.push({ title, date: new Date(current) });
        //     current.setDate(current.getDate() + 1);
        // }
        // setMissions([...missions, ...newMissions]);
    }

    // setTitle("");
    setOpen(false);
  };

  const toggleRepeatDay = (day) => {
    setRepeatDays((prev) =>
      prev.includes(day)
        ? prev.filter((d) => d !== day)
        : [...prev, day]
    );
  };

  function getMissionName(mission_id){
    var name = ""
    console.log(missions)
    missions.forEach((mission)=>{
      if(String(mission.Id) === String(mission_id)){
        name = mission.Name
      }
    })
    return name
  }

  function getTasklistName(mission_id, tasklist_id) {
    let name = "";
    missions.forEach((mission) => {
      if (mission.Id === mission_id) {
        mission.Tasklists?.forEach((tasklist) => {
          if (tasklist.Id === tasklist_id) {
            name = tasklist.RobotTasklistId.Name || "Unnamed Tasklist";
          }
        });
      }
    });
    return name;
  }

  function getTaskName(mission_id, tasklist_id, task_id) {
    let name = "";
    missions.forEach((mission) => {
      if (mission.Id === mission_id) {
        mission.Tasklists?.forEach((tasklist) => {
          if (tasklist.Id === tasklist_id) {
            tasklist.RobotTasklistId?.Tasks?.forEach((task) => {
              if (task.Id === task_id) {
                name = task.RobotTaskId.Name || "Unnamed Task";
              }
            });
          }
        });
      }
    });
    return name;
  }

  const getStatusColor = (status) => {
    switch (status) {
      case "PENDING":
        return "warning";
      case "IN_PROGRESS":
        return "info";
      case "COMPLETED":
        return "success";
      case "FAILED":
        return "error";
      default:
        return "default";
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Robot Mission Scheduler
        </Typography>
        <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setOpen(true)}
            >
            Schedule New Mission
        </Button>

        <Dialog open={open} onClose={() => setOpen(false)}>
          <DialogTitle>Schedule New Mission</DialogTitle>
          <DialogContent>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2} xs={12} sm={12} md={12}>
                <Grid item xs={12} sm={12} md={12}>
                    <Select
                        style={{width: "100%"}}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // label="Mission"
                        value={selectedMission}
                        name="Mission"
                        onChange={(e)=> setSelectedMission(e.target.value)}
                    >
                        {missions.map((mission, index)=>{
                            return(
                                <MenuItem key={index} value={mission}>
                                    {mission.Name}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <ToggleButtonGroup
                        value={mode}
                        exclusive
                        onChange={(e, newMode) => newMode && setMode(newMode)}
                    >
                        <ToggleButton value="single">Single Day</ToggleButton>
                        <ToggleButton value="range">Multiple Days</ToggleButton>
                    </ToggleButtonGroup>
                </Grid>
            </Grid>
            {mode === "single" && (
                <Grid container spacing={2} xs={12} sm={12} md={12} sx={{marginTop: 2}}>
                    <Grid item xs={12} sm={12} md={12}>
                        <DatePicker
                        label="Select Date"
                        value={selectedDate}
                        onChange={(newValue) => setSelectedDate(newValue)}
                        renderInput={(params) => <TextField fullWidth {...params} />}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                        <TimePicker
                        label="Select start time"
                        value={selectedStartTime}
                        onChange={(newValue) => setSelectedStartTime(newValue)}
                        renderInput={(params) => <TextField fullWidth {...params} />}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                        <TimePicker
                        label="Select end time"
                        value={selectedEndTime}
                        onChange={(newValue) => setSelectedEndTime(newValue)}
                        renderInput={(params) => <TextField fullWidth {...params} />}
                        />
                    </Grid>
                </Grid>
            )}

          </Box>

            {mode === "range" && (

                <Grid container spacing={2} xs={12} sm={12} md={12} sx={{marginTop: 2}}>
                    <Grid item xs={6} sm={6} md={6}>
                        <DatePicker
                        label="Start Date"
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                        renderInput={(params) => <TextField fullWidth {...params} />}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                        <DatePicker
                        label="End Date"
                        value={endDate}
                        onChange={(newValue) => setEndDate(newValue)}
                        renderInput={(params) => <TextField fullWidth {...params} />}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                        <TimePicker
                        label="Select start time"
                        value={selectedStartTime}
                        onChange={(newValue) => setSelectedStartTime(newValue)}
                        renderInput={(params) => <TextField fullWidth {...params} />}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                        <TimePicker
                        label="Select end time"
                        value={selectedEndTime}
                        onChange={(newValue) => setSelectedEndTime(newValue)}
                        renderInput={(params) => <TextField fullWidth {...params} />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                    <FormGroup row>
                        {daysOfWeek.map((day) => (
                        <FormControlLabel
                            key={day}
                            control={
                            <Checkbox
                                checked={repeatDays.includes(day)}
                                onChange={() => toggleRepeatDay(day)}
                            />
                            }
                            label={day.slice(0, 3)}
                        />
                        ))}
                    </FormGroup>
                    </Grid>
                </Grid>
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSchedule}>Save</Button>
          </DialogActions>
        </Dialog>

        <Box sx={{ mt: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
            <Typography variant="h6">Scheduled Missions:</Typography>
            <Stack direction="row" spacing={1}>
                <Button
                    size="small"
                    variant="outlined"
                    onClick={handleRefreshSchedule}
                    disabled={isRefreshingSchedule}
                    startIcon={<RefreshIcon />}
                >
                    {isRefreshingSchedule ? 'Refreshing' : 'Refresh'}
                </Button>
                <Button
                    size="small"
                    variant="outlined"
                    onClick={handleRepullSchedule}
                    disabled={isRepullingSchedule || !props.robotName}
                    startIcon={<SyncIcon />}
                >
                    {isRepullingSchedule ? 'Pulling' : 'Repull'}
                </Button>
            </Stack>
          </Box>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={6} sm={6} md={6}>
                    <DatePicker
                    label="Start"
                    value={startFilteredDate}
                    onChange={(newValue) => setStartFilteredDate(new Date(new Date(newValue).setHours(0, 0, 0, 0)))}
                    renderInput={(params) => <TextField fullWidth {...params} />}
                    />
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                    <DatePicker
                    label="End"
                    value={endFilteredDate}
                    onChange={(newValue) => setEndFilteredDate(new Date(new Date(newValue).setHours(23, 59, 59, 99)))}
                    renderInput={(params) => <TextField fullWidth {...params} />}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 1 }}>
                {groupedSchedules.length === 0 ? (
                    <Grid item xs={12}>
                        <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', py: 3 }}>
                            No scheduled missions in this date range
                        </Typography>
                    </Grid>
                ) : (
                  groupedSchedules.map((group) => (
                    <React.Fragment key={group.key}>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 2,
                                mt: 1,
                                px: 1.5,
                                py: 1,
                                borderRadius: 1,
                                bgcolor: 'action.hover',
                                border: '1px solid',
                                borderColor: 'divider',
                            }}
                        >
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary' }}>
                                {group.dateLabel}
                            </Typography>
                            <Chip
                                label={`${group.period} · ${group.schedules.length} mission${group.schedules.length !== 1 ? 's' : ''}`}
                                size="small"
                                color={group.period === 'Morning' ? 'primary' : group.period === 'Afternoon' ? 'warning' : 'default'}
                                variant="outlined"
                            />
                        </Box>
                    </Grid>
                    {group.schedules.map((schedule, index) => {
                    const startDate = formatLocalDateTime(schedule.MissionStartAt, { month: 'short', day: 'numeric', weekday: 'short' });
                    const startTime = formatLocalDateTime(schedule.MissionStartAt, { hour: '2-digit', minute: '2-digit' });
                    return (
                <Grid item xs={12} sm={6} md={4} key={schedule.Id || `${group.key}-${index}`}>
                    <Paper sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
                                <Box sx={{ minWidth: 78, px: 1, py: 0.75, borderRadius: 1, bgcolor: 'primary.main', color: 'primary.contrastText', textAlign: 'center' }}>
                                    <Typography sx={{ fontSize: '0.7rem', lineHeight: 1.1 }}>
                                        {startDate}
                                    </Typography>
                                    <Typography sx={{ fontSize: '1rem', fontWeight: 700, lineHeight: 1.2 }}>
                                        {startTime}
                                    </Typography>
                                </Box>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {getMissionName(schedule.RobotMissionId)}
                                </Typography>
                            </Box>
                            <Typography variant="body2" sx={{ mt: 0.5, color: 'text.secondary' }}>
                                Start: {formatLocalDateTime(schedule.MissionStartAt)}
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 0.5, color: 'text.secondary' }}>
                                End: {formatLocalDateTime(schedule.MissionEndAt)}
                            </Typography>
                            <Box sx={{ mt: 1 }}>
                                <Chip
                                    label={schedule.Status}
                                    color={getStatusColor(schedule.Status)}
                                    size="small"
                                    variant="outlined"
                                />
                            </Box>
                        </Box>
                        <Button
                            size="small"
                            onClick={() => setExpandedSchedule(expandedSchedule === schedule.Id ? null : schedule.Id)}
                            sx={{
                                minWidth: 'auto',
                                transform: expandedSchedule === schedule.Id ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s'
                            }}
                        >
                            <ExpandMoreIcon />
                        </Button>
                    </Box>

                    {/* Expanded Details */}
                    <Collapse in={expandedSchedule === schedule.Id} timeout="auto" unmountOnExit>
                        <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid #e0e0e0' }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 2 }}>
                                Task Details
                            </Typography>
                            {schedule.ScheduledTasklists && schedule.ScheduledTasklists.length > 0 ? (
                                schedule.ScheduledTasklists.map((tasklist, tasklistIndex) => (
                                    <Box key={tasklistIndex} sx={{ mb: 2 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 1 }}>
                                            📋 {getTasklistName(schedule.RobotMissionId, tasklist.MissionTasklistId)}
                                        </Typography>
                                        <Box sx={{ ml: 2 }}>
                                            <Chip
                                                label={`Tasklist: ${tasklist.Status}`}
                                                color={getStatusColor(tasklist.Status)}
                                                size="small"
                                                sx={{ mb: 1 }}
                                            />
                                            {tasklist.ScheduledTasks && tasklist.ScheduledTasks.length > 0 ? (
                                                <TableContainer>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                                                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Task</TableCell>
                                                                <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Status</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {tasklist.ScheduledTasks.map((task, taskIndex) => (
                                                                <TableRow key={taskIndex}>
                                                                    <TableCell sx={{ fontSize: '0.75rem', py: 0.5 }}>
                                                                        {getTaskName(schedule.RobotMissionId, tasklist.MissionTasklistId, task.TasklistTaskId)}
                                                                    </TableCell>
                                                                    <TableCell align="right" sx={{ py: 0.5 }}>
                                                                        <Chip
                                                                            label={task.Status}
                                                                            color={getStatusColor(task.Status)}
                                                                            size="small"
                                                                            variant="outlined"
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            ) : (
                                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                    No tasks in this tasklist
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                                ))
                            ) : (
                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                    No tasklists assigned
                                </Typography>
                            )}
                        </Box>
                    </Collapse>

                    {/* Buttons */}
                    <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                        {/* <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            fullWidth
                        >
                            View
                        </Button> */}
                        <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            fullWidth
                            onClick={() => handleDeleteSchedule(schedule.Id)}
                        >
                            Delete
                        </Button>
                    </Stack>
                    </Paper>
                </Grid>
                    );
                  })}
                    </React.Fragment>
                  ))
                )}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </LocalizationProvider>
  );
}
